"use client";

import { MapPin } from "lucide-react";
export default function ClinicLocationMap() {
  return;
}